import { render } from "./PrivacyPolicy.vue?vue&type=template&id=313e9287&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=313e9287&scoped=true&lang=css"

import exportComponent from "/Users/matsunohiroshi/myact/smari/sumari-deliverybox/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313e9287"]])

export default __exports__